import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Trans } from '@lingui/react/macro';
import { useOptionConfigurator } from '../OptionConfiguratorContext';
import { ROOM_PLACEHOLDER_IMAGE_URL } from '../roomPlaceholderImage';
import theme from './OptionsStartCustomizationHero.module.scss';

// Full-width hero banner shown above the configurator tab menu. Clicking it takes the user (same
// tab) into the authenticated immersive configurator at `<baseUrl>/configurator`, where selections
// persist to the backend. Rendered for both the buyer flow and the seller options tab — both wire
// the immersive route (see BuyerOptionConfigurator / SellerOptionConfigurator).
export const OptionsStartCustomizationHero: React.FC = () => {
    const history = useHistory();
    const location = useLocation();
    const { baseUrl } = useOptionConfigurator();

    // Hide on the signing flow (pre-sign + sign) — a "start customization" CTA makes no sense there.
    const isSigningRoute = /\/sign(-pre|\/)/.test(location.pathname);

    if (isSigningRoute) return null;

    return (
        <button
            type="button"
            className={theme.hero}
            style={{ backgroundImage: `url(${ROOM_PLACEHOLDER_IMAGE_URL})` }}
            onClick={() => history.push(`${baseUrl}/configurator`)}>
            <span className={theme.overlay} aria-hidden="true" />
            <span className={theme.label}>
                <Trans>Start customization</Trans>
            </span>
        </button>
    );
};
